module.exports = __webpack_public_path__ + "static/fonts/Oswald-RegularItalic.b5e1a9c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-RegularItalic.ttf
// module id = MlfU
// module chunks = 1